// import { forwardRef } from 'react';
import Tooltip from '@mui/material/Tooltip';

export function flagEmojiString(countryIsoCode?: string) {
  if (!countryIsoCode) return null;

  return countryIsoCode.toUpperCase().replace(/./g, (c) => String.fromCodePoint(c.charCodeAt(0) + 127397)) + ' ';
}

// eslint-disable-next-line react-refresh/only-export-components
export function flagsWithGeoAdressString({
  countryCode,
  geocodedAddress,
}: {
  countryCode?: string;
  geocodedAddress?: string;
}) {
  const flagAndSpace = flagEmojiString(countryCode);
  return `${flagAndSpace ?? ''}${geocodedAddress ?? ''}`;
}

type FlagComponentProps = {
  countryCode?: string;
};

function FlagComponent1(props: FlagComponentProps) {
  if (!props.countryCode) return null;

  return (
    <span
      data-qa-element-id="flag_icon"
      style={{
        isolation: 'isolate',
        display: 'inline-block',
        paddingRight: '10px',
        fontSize: '1.25rem',
        fontFamily: 'Twemoji',
      }}
    >
      {props.countryCode.toUpperCase().replace(/./g, (c) => String.fromCodePoint(c.charCodeAt(0) + 127397))}
    </span>
  );
}

/*
// https://mui.com/material-ui/react-tooltip/#custom-child-element
// deprecated in React19 :(
const FlagComponent = forwardRef<HTMLDivElement, FlagComponentProps>((props: FlagComponentProps, ref) => {
  if (!props.countryCode) return null;

  return (
    <span
      ref={ref}
      style={{
        isolation: 'isolate',
        display: 'inline-block',
        paddingRight: '10px',
        fontSize: '1.25rem',
        fontFamily: 'Twemoji',
      }}
    >
      {props.countryCode.toUpperCase().replace(/./g, (c) => String.fromCodePoint(c.charCodeAt(0) + 127397))}
    </span>
  );
});
*/

export default function FlagsWithGeoAdress({
  countryCode,
  countryName,
  geocodedAddress,
}: {
  countryCode?: string;
  countryName?: string;
  geocodedAddress?: string;
}) {
  // eslint-disable-next-line no-constant-binary-expression
  const withTooltip = false && countryName;

  return (
    <>
      {withTooltip ? (
        <Tooltip
          data-qa-element-id="route_title"
          title={countryName}
          placement={'top'}
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: { offset: [0, -14] },
                },
              ],
            },
          }}
        >
          <FlagComponent1 countryCode={countryCode} />
        </Tooltip>
      ) : (
        <FlagComponent1 countryCode={countryCode} />
      )}
      {geocodedAddress && <span data-qa-element-id="route_address">{geocodedAddress}</span>}
    </>
  );
}
